(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('qsched-direction', {
            parent: 'entity',
            url: '/qsched-direction',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_direction.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-direction/qsched-directions.html',
                    controller: 'Qsched_directionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_direction');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('qsched-direction-detail', {
            parent: 'entity',
            url: '/qsched-direction/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.qsched_direction.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-detail.html',
                    controller: 'Qsched_directionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('qsched_direction');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Qsched_direction', function($stateParams, Qsched_direction) {
                    return Qsched_direction.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'qsched-direction',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('qsched-direction-detail.edit', {
            parent: 'qsched-direction-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-dialog.html',
                    controller: 'Qsched_directionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_direction', function(Qsched_direction) {
                            return Qsched_direction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-direction.new', {
            parent: 'qsched-direction',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-dialog.html',
                    controller: 'Qsched_directionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                direction: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('qsched-direction', null, { reload: 'qsched-direction' });
                }, function() {
                    $state.go('qsched-direction');
                });
            }]
        })
        .state('qsched-direction.edit', {
            parent: 'qsched-direction',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-dialog.html',
                    controller: 'Qsched_directionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Qsched_direction', function(Qsched_direction) {
                            return Qsched_direction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-direction', null, { reload: 'qsched-direction' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('qsched-direction.delete', {
            parent: 'qsched-direction',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/qsched-direction/qsched-direction-delete-dialog.html',
                    controller: 'Qsched_directionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Qsched_direction', function(Qsched_direction) {
                            return Qsched_direction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('qsched-direction', null, { reload: 'qsched-direction' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
